// @ts-nocheck
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { CSSProperties } from 'react';
import { Form, FormControlProps } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';

export interface SearchBoxProps extends FormControlProps {
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  formClassName?: string;
  size?: 'sm' | 'lg';
  style?: CSSProperties;
  id?: string;
}

const SearchBox = ({
  searchBoolean,
  closeDropdown,
  placeholder = 'Search',
  size,
  className,
  inputClassName,
  formClassName,
  style,
  ...rest
}: SearchBoxProps) => {
  const [searchValue, setSearchValue] = useState('');
  let navigate = useNavigate();

  function register(event) {
    event.preventDefault();
    navigate(`/primedeco/product-table?s=${searchValue}`);
    setSearchValue('');
    searchBoolean && closeDropdown();
  }

  function handleChange(event) {
    setSearchValue(event.target.value);
  }

  return (
    <div className={classNames('search-box', className)} style={style}>
      <form
        className={classNames('position-relative', formClassName)}
        onSubmit={register}
      >
        <Form.Control
          onKeyPress={event => {
            handleChange(event);
          }}
          type="search"
          placeholder={placeholder}
          className={classNames('search-input search', inputClassName)}
          size={size}
          {...rest}
        />
        <FontAwesomeIcon icon={faSearch} className="search-box-icon" />
      </form>
    </div>
  );
};

export default SearchBox;
